const canUseDOM =
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement

const CONFIG_FILE_NAME = 'react-config.json'
const CONFIG_URL_CDN = canUseDOM ? window.REACT_CONFIG_CDN_URL : null

// SSR (Node.js)
function loadConfigSSR() {
  try {
    const fs = require('fs')
    const path = require('path')
    const configPath = path.resolve(process.cwd(), CONFIG_FILE_NAME)
    const configContent = fs.readFileSync(configPath, 'utf8')
    global.__RUNTIME_CONFIG__ = JSON.parse(configContent)
  } catch (err) {
    console.error('[REACT] Failed to load runtime config:', err)
  }
}

function loadConfigBrowserSync() {
  try {
    if (!CONFIG_URL_CDN) {
      throw new Error('[REACT] REACT_CONFIG_CDN_URL is not defined')
    }

    // The config URL already carries a deploy-tied cache-busting param
    // (?v=<deploy>) injected by Drupal (PMIRRPJP-75179). Request it verbatim so
    // the CDN and browser cache it within a release and only refetch on the
    // next deploy, instead of busting the cache on every page load.
    const request = new window.XMLHttpRequest()
    request.open('GET', CONFIG_URL_CDN, false)
    request.send(null)

    if (request.status < 200 || request.status >= 300) {
      throw new Error(
        `[REACT] Failed to fetch runtime config: ${request.status}`
      )
    }

    window.__RUNTIME_CONFIG__ = JSON.parse(request.responseText)
  } catch (err) {
    console.error(
      '[REACT] Failed to load runtime config from:',
      CONFIG_URL_CDN,
      err
    )
  }
}

module.exports = {
  canUseDOM,
  loadConfigSSR,
  loadConfigBrowserSync
}
